import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BrainCircuitIcon, BatteryWarningIcon } from 'lucide-react';
export function PainSection() {
  return <section className="pt-10 pb-16 md:py-24 px-4 bg-[#0d0d12] relative border-t border-white/5" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        {/* The Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="mb-20" data-id="element-63">
          <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6" data-id="element-64">
            <BrainCircuitIcon className="w-6 h-6 text-[#00d4ff]" data-id="element-65" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-66">
            ¿Te ha pasado que cierras la laptop a las 6:00 PM pero tu cerebro
            sigue encendido a mil revoluciones?
          </h2>
          <div className="space-y-6 text-lg text-gray-400 leading-relaxed" data-id="element-67">
            <p data-id="element-68">
              Miras a tu familia, pero tu mente sigue en el Slack. Intentas
              dormir, pero repasas la lista de pendientes por vigésima vez.
            </p>
            <p data-id="element-69">
              Ese nudo en el estómago tiene un nombre:{' '}
              <strong className="text-white font-medium" data-id="element-70">
                Secuestro por Cortisol
              </strong>
              . Tu cuerpo está en modo "supervivencia" y, lamentablemente, una
              app con sonidos de lluvia no va a sacarte de ahí.
            </p>
          </div>
        </motion.div>

        {/* Pain Agitation */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="p-8 md:p-10 rounded-3xl bg-gradient-to-br from-white/5 to-transparent border border-white/10 relative overflow-hidden" data-id="element-71">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full blur-[80px] pointer-events-none" data-id="element-72" />

          <div className="flex items-center gap-4 mb-6" data-id="element-73">
            <BatteryWarningIcon className="w-8 h-8 text-red-400" data-id="element-74" />
            <h3 className="text-2xl font-bold text-white" data-id="element-75">
              El Costo de la Fatiga Digital
            </h3>
          </div>

          <div className="space-y-6 text-lg text-gray-400 leading-relaxed relative z-10" data-id="element-76">
            <p data-id="element-77">
              Vivimos en la era de la fatiga digital. Tu atención es el petróleo
              del siglo XXI y cada notificación roja en tu teléfono está
              diseñada para disparar tu respuesta de "lucha o huida".
            </p>
            <p data-id="element-78">
              Estás operando en un estado de emergencia constante. Tu memoria
              falla, tu irritabilidad sube y la "niebla mental" se ha convertido
              en tu estado normal.
            </p>
            <p className="text-white font-medium border-l-2 border-red-500/50 pl-4 py-1" data-id="element-79">
              El costo no es solo el estrés; es perder años de vida productiva y
              momentos reales con la gente que amas porque, aunque estás
              presente físicamente, tu mente está "quemada".
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}